import { axiosInstance as axios } from '../../boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    MainNews({ commit, rootGetters }, request) {
      return axios
        .post('MainNews', request)
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    NewsList({ commit, rootGetters }, request) {
      return axios
        .post('NewsList', request)
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    NewsRead({ commit, rootGetters }, request) {
      return axios
        .post('NewsRead', {
          NewsGuid: request.NewsGuid
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('訊息公告讀取失敗')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetRobotSpecificationList({ commit, rootGetters }, request) {
      return axios
        .post('GetRobotSpecificationList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else {
            return Promise.reject('讀取失敗')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddRobotSpecification({ commit, rootGetters }, request) {
      return axios
        .post('AddRobotSpecification', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject('名稱重複！')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateRobotSpecificationFile({ commit, rootGetters }, request) {
      return axios
        .post('UpdateRobotSpecificationFile', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject('名稱重複！')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    DeleteRobotSpecification({ commit, rootGetters }, request) {
      return axios
        .post('DeleteRobotSpecification', {
          ...request
        })
        .then((response) => {
          return Promise.resolve(response.data.Values)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
